<template>
  <el-table-column
    prop="storage.id"
    sortable="custom"
    label="Szállító raktár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.storage.name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'storage.id',
};
</script>
